/**
 * Hairstory Hair Quiz Web Component
 * A vanilla JS web component that replicates the React quiz functionality
 */

// Klaviyo subscription helper
const KLAVIYO_SITE_ID = 'S8MmSD';

async function subscribeToKlaviyoMarketing(email) {
  try {
    await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_SITE_ID}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        'revision': '2026-01-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'TDbjLH'
              }
            }
          }
        }
      })
    });
  } catch (err) {
    console.error('Error subscribing to Klaviyo:', err);
  }
}

// Bundle discount tiers (matches bundle-builder logic)
function getBundleDiscountRate(count) {
  if (count >= 4) return 0.2;
  if (count === 3) return 0.15;
  if (count === 2) return 0.1;
  return 0;
}

// Product data mapping for recommendation rendering (matches hair-chat.js)
const QUIZ_PRODUCT_DATA = {
  "new wash original": {
    name: "New Wash Original",
    imageUrl: "https://hairstory.com/cdn/shop/files/NWO_8_Product_-_Bottle.jpg",
    productUrl: "https://hairstory.com/products/new-wash-original",
    price: "$48",
    handle: "new-wash-original",
    sku: "850065187327",
    variantId: "45965755711718"
  },
  "new wash rich": {
    name: "New Wash Rich",
    imageUrl: "https://hairstory.com/cdn/shop/files/NWR8Product-Bottle.jpg",
    productUrl: "https://hairstory.com/products/new-wash-rich",
    price: "$48",
    handle: "new-wash-rich",
    sku: "850065187341",
    variantId: "45965800407270"
  },
  "new wash deep clean": {
    name: "New Wash Deep Clean",
    imageUrl: "https://hairstory.com/cdn/shop/files/NWD8Product-Bottle.jpg",
    productUrl: "https://hairstory.com/products/new-wash-deep-clean",
    price: "$48",
    handle: "new-wash-deep-clean",
    sku: "850065187334",
    variantId: "45965770522854"
  },
  "pre-wash": {
    name: "Pre-Wash",
    imageUrl: "https://hairstory.com/cdn/shop/files/PREWASH.png",
    productUrl: "https://hairstory.com/products/pre-wash-4-oz",
    price: "$28",
    handle: "pre-wash-4-oz",
    sku: "850051150700",
    variantId: "45303092838630"
  },
  "primer": {
    name: "Primer",
    imageUrl: "https://hairstory.com/cdn/shop/files/PRIMER_d73da503-c688-49fe-a869-1c9e936a9226.jpg",
    productUrl: "https://hairstory.com/products/primer-8-oz",
    price: "$36",
    handle: "primer-8-oz",
    sku: "850051150717",
    variantId: "45303092871398"
  },
  "hair balm": {
    name: "Hair Balm",
    imageUrl: "https://hairstory.com/cdn/shop/files/Hair_Balm.jpg",
    productUrl: "https://hairstory.com/products/hair-balm-4-oz",
    price: "$37",
    handle: "hair-balm-4-oz",
    sku: "850065187044",
    variantId: "45104210739430"
  },
  "oil": {
    name: "Oil",
    imageUrl: "https://hairstory.com/cdn/shop/files/Oil.jpg",
    productUrl: "https://hairstory.com/products/hair-oil-2-oz-refill",
    price: "$37",
    handle: "hair-oil-2-oz-refill",
    sku: "850065187099",
    variantId: "45104210772198"
  },
  "undressed": {
    name: "Undressed",
    imageUrl: "https://hairstory.com/cdn/shop/files/Undressed.jpg",
    productUrl: "https://hairstory.com/products/undressed-8-oz",
    price: "$38",
    handle: "undressed-8-oz",
    sku: "850065187051",
    variantId: "45104456106214"
  },
  "powder": {
    name: "Powder",
    imageUrl: "https://hairstory.com/cdn/shop/files/Powder.jpg",
    productUrl: "https://hairstory.com/products/powder",
    price: "$37",
    handle: "powder",
    sku: "850065187075",
    variantId: "45104456007910"
  },
  "root lift": {
    name: "Root Lift",
    imageUrl: "https://hairstory.com/cdn/shop/files/RootLIFT.jpg",
    productUrl: "https://hairstory.com/products/lift-8-oz",
    price: "$38",
    handle: "lift-8-oz",
    sku: "850065187082",
    variantId: "45104455450854"
  },
  "wax": {
    name: "Wax",
    imageUrl: "https://hairstory.com/cdn/shop/files/WAX.jpg",
    productUrl: "https://hairstory.com/products/wax-2-oz",
    price: "$29",
    handle: "wax-2-oz",
    sku: "850065187068",
    variantId: "45104456204518"
  },
  "bond serum": {
    name: "Bond Serum",
    imageUrl: "https://hairstory.com/cdn/shop/files/PS_Bond-Serum-2oz.jpg",
    productUrl: "https://hairstory.com/products/bond-serum-2-oz",
    price: "$44",
    handle: "bond-serum-2-oz",
    sku: "850065187020",
    variantId: "45475329179878"
  },
  "styling gel": {
    name: "Styling Gel",
    imageUrl: "https://hairstory.com/cdn/shop/files/Styling_gel_8oz.jpg",
    productUrl: "https://hairstory.com/products/styling-gel-bottle",
    price: "$34",
    handle: "styling-gel-bottle",
    sku: "850065187778",
    variantId: "46688025510118"
  }
};

function getQuizProductData(productName) {
  const normalizedName = productName.toLowerCase().trim();

  if (QUIZ_PRODUCT_DATA[normalizedName]) {
    return QUIZ_PRODUCT_DATA[normalizedName];
  }

  for (const [key, value] of Object.entries(QUIZ_PRODUCT_DATA)) {
    if (normalizedName.includes(key) || key.includes(normalizedName)) {
      return value;
    }
  }

  return {
    name: productName,
    imageUrl: null,
    productUrl: null,
    price: null
  };
}

class HairQuiz extends HTMLElement {
  // ============================================================================
  // STATIC DATA
  // ============================================================================


  static PHASES = {
    INTRO: 'intro',
    QUIZ: 'quiz',
    EMAIL_CAPTURE: 'email_capture',
    LOADING: 'loading',
    RESULTS: 'results'
  };

  static CohortType = {
    CURLY_COILY: 'Curly+Coily',
    DAMAGED: 'Damaged',
    FINE: 'Fine',
    GRAY: 'Gray',
    THICK_DRY: 'Thick+Dry',
    TRIAL_KIT: 'Trial Kit'
  };

  static NewWashProduct = {
    NEW_WASH_RICH: 'new-wash-rich',
    NEW_WASH_ORIGINAL: 'new-wash-original'
  };

  static StylingProducts = {
    GEL: 'styling-gel-bottle',
    HAIR_BALM: 'hair-balm-4-oz',
    HAIR_OIL: 'hair-oil-2-oz-refill',
    LIFT: 'lift-8-oz',
    POWDER: 'powder',
    UNDRESSED: 'undressed-8-oz',
    WAX: 'wax-2-oz',
    PRIMER: 'primer-8-oz',
    PRE_WASH: 'pre-wash-4-oz',
    BOND_SERUM: 'bond-serum-2-oz'
  };

  static PRODUCT_RECOMMENDATION_DICT = {
    'new-wash-original': {
      name: 'New Wash Original',
      id: '9018262323430',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/NWO_8_Product_-_Bottle.jpg?v=1751890030',
      sku: '850065187327',
      url: 'https://hairstory.com/products/new-wash-original'
    },
    'new-wash-rich': {
      name: 'New Wash Rich',
      id: '9018332512486',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/NWR8Product-Bottle.jpg?v=1751892069',
      sku: '850065187341',
      url: 'https://hairstory.com/products/new-wash-rich'
    },
    'styling-gel-bottle': {
      name: 'Styling Gel',
      id: '9424871456998',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/Styling_gel_8oz.jpg?v=1759530069',
      sku: '850065187778',
      url: 'https://hairstory.com/products/styling-gel-bottle'
    },
    'hair-balm-4-oz': {
      name: 'Hair Balm',
      id: '8740491100390',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/Hair_Balm.jpg?v=1751999961',
      sku: '850013498284',
      url: 'https://hairstory.com/products/hair-balm-4-oz'
    },
    'hair-oil-2-oz-refill': {
      name: 'Oil',
      id: '8740491133158',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/Oil.jpg?v=1752000316',
      sku: '850065187099',
      url: 'https://hairstory.com/products/hair-oil-2-oz-refill'
    },
    'undressed-8-oz': {
      name: 'Undressed',
      id: '8740625055974',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/Undressed.jpg?v=1752000460',
      sku: '850065187051',
      url: 'https://hairstory.com/products/undressed-8-oz'
    },
    'lift-8-oz': {
      name: 'Root Lift',
      id: '8740624400614',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/RootLIFT.jpg?v=1752002237',
      sku: '850065187082',
      url: 'https://hairstory.com/products/lift-8-oz'
    },
    'powder': {
      name: 'Powder',
      id: '8740624957670',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/Powder.jpg?v=1752000528',
      sku: '850065187075',
      url: 'https://hairstorystudio.myshopify.com/products/powder'
    },
    'wax-2-oz': {
      name: 'Wax',
      id: '8740625154278',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/WAX.jpg?v=1752011072',
      sku: '850065187068',
      url: 'https://hairstory.com/products/wax-2-oz'
    },
    'primer-8-oz': {
      name: 'Primer',
      id: '8816637477094',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/PS_Primer-8oz.jpg?v=1728400804',
      sku: '850051150717',
      url: 'https://hairstory.com/products/primer-8-oz'
    },
    'pre-wash-4-oz': {
      name: 'Pre-Wash',
      id: '8816637411558',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/PS_Pre-Wash-4oz.jpg?v=1728400863',
      sku: '850051150700',
      url: 'https://hairstory.com/products/pre-wash-4-oz'
    },
    'bond-serum-2-oz': {
      name: 'Bond Serum',
      id: '8877778665702',
      image_url: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/PS_Bond-Serum-2oz.jpg?v=1728400863',
      sku: '850065187020',
      url: 'https://hairstory.com/products/bond-serum-2-oz'
    }
  };

  static QUESTIONS = [
    {
      id: 'how_often_wash_hair',
      text: 'How often do you wash your hair?',
      subtext: '',
      type: 'radio',
      options: [
        { value: 'every_day', label: 'Every day' },
        { value: 'every_2_3_days', label: 'Every 2-3 days' },
        { value: 'once_a_week', label: 'Once a week' },
        { value: 'less_than_once_a_week', label: 'Less than once a week' }
      ]
    },
    {
      id: 'hair_texture',
      modal: 'WhyWeAskModal',
      text: 'What is your hair texture?',
      subtext: 'Texture is all about the thickness of each individual strand, not how much hair you have overall. What does a single strand feel like when you roll it between two fingers?',
      type: 'radio',
      options: [
        {
          value: 'fine',
          label: 'Fine',
          subtext: 'Thinner than a strand of thread',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/1s.png?v=1765410307&width=200&height=200'
        },
        {
          value: 'normal',
          label: 'Normal',
          subtext: 'As thick as a strand of thread',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/2nd.png?v=1765410307&width=200&height=200'
        },
        {
          value: 'thick_coarse',
          label: 'Thick or Coarse',
          subtext: 'Thicker than a strand of thread',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/3rd.png?v=1765410306&width=200&height=200'
        }
      ]
    },
    {
      id: 'hair_type',
      text: 'What is your natural hair type?',
      modal: 'HairTypeModal',
      subtext: "Different curl patterns need different levels of support and cleansing — we'll help you get it right.",
      type: 'radio',
      options: [
        {
          value: 'straight',
          label: 'Straight',
          subtext: 'No bend or wave',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/brown-hair-2.png?v=1768188108&width=200&height=200'
        },
        {
          value: 'wavy',
          label: 'Wavy',
          subtext: 'Naturally has a loose S-shape',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/blonde.png?v=1765410329&width=200&height=200'
        },
        {
          value: 'curly',
          label: 'Curly',
          subtext: 'Defined spirals with lots of bounce',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/red-hair-2.png?v=1768188108&width=200&height=200'
        },
        {
          value: 'coily',
          label: 'Coily',
          subtext: 'Tightly coiled strands.',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/dark-hair-2.png?v=1768188108&width=200&height=200'
        }
      ]
    },
    {
      id: 'concernArray',
      text: 'What are your primary hair concerns?',
      subtext: 'Select as many as applicable.',
      type: 'checkbox',
      options: [
        { value: 'oiliness', label: 'Oiliness' },
        { value: 'dryness', label: 'Dryness' },
        { value: 'frizziness', label: 'Frizziness' },
        { value: 'breakage_damage', label: 'Breakage or Damage' },
        { value: 'curl_support', label: 'Curl Support' },
        { value: 'dullness', label: 'Dullness' },
        { value: 'color_maintenance', label: 'Color Maintenance' },
        { value: 'product_buildup', label: 'Product Buildup' },
        { value: 'none', label: 'None' }
      ]
    },
    {
      id: 'primary_scalp_concern',
      text: 'What is your primary scalp concern?',
      subtext: '',
      type: 'radio',
      options: [
        { value: 'dryness_flakiness', label: 'Dryness or Flakiness' },
        { value: 'irritation', label: 'Irritation' },
        { value: 'oiliness', label: 'Oiliness' },
        { value: 'none', label: 'None' }
      ]
    },
    {
      id: 'hair_color',
      text: 'Which of the following applies to your hair color?',
      subtext: '',
      type: 'radio',
      options: [
        {
          value: 'gray_hair',
          label: 'I have gray hair',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/platinum-hair-2.png?v=1768188108&width=200&height=200'
        },
        {
          value: 'color_my_hair',
          label: 'I color my hair',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/blonde.png?v=1765410329&width=200&height=200'
        },
        {
          value: 'natural_no_gray',
          label: 'I leave it natural and I have few or no gray hairs',
          image: 'https://cdn.shopify.com/s/files/1/0653/5007/4598/files/dark-hair-2.png?v=1768188108&width=200&height=200'
        }
      ]
    },
    {
      id: 'shade_color',
      text: 'What shade or color most closely applies to your hair?',
      subtext: '',
      condition: { previousAnswer: 'color_my_hair' },
      type: 'radio',
      options: [
        { value: 'blonde', label: 'Blonde or Blonde Highlights' },
        { value: 'red', label: 'Red or Red Highlights' },
        { value: 'platinum', label: 'Platinum Blonde' },
        { value: 'brown', label: 'Brown' },
        { value: 'black', label: 'Black' },
        { value: 'creative_colors', label: 'Creative Colors (Pink, Purple, Green, Blue, Others)' }
      ]
    },
    {
      id: 'stylingProductsArray',
      text: 'What Styling Products do you currently use?',
      subtext: 'Select as many as applicable.',
      type: 'checkbox',
      options: [
        { value: 'volumizing_thickening_spray', label: 'Volumizing or Thickening Spray' },
        { value: 'wax_pomade', label: 'Wax or Pomade' },
        { value: 'gel', label: 'Gel' },
        { value: 'styling_cream', label: 'Styling Cream' },
        { value: 'leave_in_conditioner', label: 'Leave In Conditioner' },
        { value: 'hair_oil_serum', label: 'Hair Oil or Serum' },
        { value: 'texturizing_beach_spray', label: 'Texturizing or Beach Spray' },
        { value: 'heat_protectant', label: 'Heat Protectant' },
        { value: 'dry_shampoo_powder', label: 'Dry Shampoo or Powder' },
        { value: 'none', label: 'None' }
      ]
    }
  ];

  static HAIR_TYPE_LIST = [
    { hairType: '1-2A', hairDescriptor: 'Straight Hair', description: 'Sleek, no wave or minimal bend.' },
    { hairType: '2B', hairDescriptor: 'Straight-Wavy Hair', description: 'Slight bend starting mid-length.' },
    { hairType: '3A', hairDescriptor: 'Wavy-Curly Hair', description: 'Loose curls that form an S-shape.' },
    { hairType: '3B', hairDescriptor: 'Curly Hair', description: 'Springy spirals with defined bounce.' },
    { hairType: '3C', hairDescriptor: 'Tight-Curly Hair', description: 'Dense curls with less definition.' },
    { hairType: '4A', hairDescriptor: 'Coily-Curly Hair', description: 'Small corkscrews with softness.' },
    { hairType: '4B', hairDescriptor: 'Kinky Curly Hair', description: 'Zig-zag pattern with volume.' },
    { hairType: '4C', hairDescriptor: 'Kinky-Coily-Curly Hair', description: 'Tightest coils, soft but fragile.' }
  ];

  // ============================================================================
  // CONSTRUCTOR
  // ============================================================================

  constructor() {
    super();

    // Quiz state
    this.state = {
      phase: HairQuiz.PHASES.INTRO,
      currentStep: 0,
      formData: {},
      cohort: '',
      productRecommendations: '',
      userEmail: '',
      completed: false
    };

    // Checkbox state for current question
    this.currentCheckboxValues = [];
    this.showValidation = false;

    // Modal state
    this.activeModal = null;

    // AI recommendation data
    this.aiRecommendation = null;

    // Product modals reference
    this.productModals = null;
  }

  // ============================================================================
  // LIFECYCLE
  // ============================================================================

  connectedCallback() {
    // Intro is always server-rendered via Liquid, just attach event listeners
    this.attachEventListeners();

    // Cache product modal references
    this.productModals = this.querySelectorAll('[data-product-modal-handle]');
    this.initializeProductModals();
  }

  // ============================================================================
  // STATE MANAGEMENT
  // ============================================================================

  setState(updates) {
    this.state = { ...this.state, ...updates };
    this.render();
    this.attachEventListeners();
  }

  setFormData(key, value) {
    this.state.formData = { ...this.state.formData, [key]: value };
  }

  // ============================================================================
  // UTILITY METHODS
  // ============================================================================

  getUserCohort(formData) {
    const damagedCohortList = ['frizziness', 'breakage_damage', 'color_maintenance'];
    const dullOrDryCohortList = ['dullness', 'dryness'];

    const concernArray = formData.concernArray || [];
    const isUserDamagedCohort = damagedCohortList.some(criteria => concernArray.includes(criteria));
    const isUserDullorDryCohort = dullOrDryCohortList.some(criteria => concernArray.includes(criteria));

    if (formData.hair_type === 'curly' || formData.hair_type === 'coily') {
      return HairQuiz.CohortType.CURLY_COILY;
    } else if (formData.hair_texture === 'fine') {
      return HairQuiz.CohortType.FINE;
    } else if (isUserDamagedCohort) {
      return HairQuiz.CohortType.DAMAGED;
    } else if (formData.hair_color?.includes('gray_hair')) {
      return HairQuiz.CohortType.GRAY;
    } else if (isUserDullorDryCohort) {
      return HairQuiz.CohortType.THICK_DRY;
    } else {
      return HairQuiz.CohortType.TRIAL_KIT;
    }
  }

  calculateNewWashProductRecommendation(formData) {
    const priorityThreeNewWashList = ['dryness', 'breakage_damage'];
    const concernArray = formData.concernArray || [];

    if (formData.hair_type === 'coily') {
      return HairQuiz.NewWashProduct.NEW_WASH_RICH;
    } else if (formData.hair_texture === 'fine') {
      return HairQuiz.NewWashProduct.NEW_WASH_ORIGINAL;
    } else if (priorityThreeNewWashList.every(result => concernArray.includes(result))) {
      return HairQuiz.NewWashProduct.NEW_WASH_RICH;
    } else if (formData.how_often_wash_hair === 'every_day') {
      return HairQuiz.NewWashProduct.NEW_WASH_ORIGINAL;
    } else {
      return HairQuiz.NewWashProduct.NEW_WASH_ORIGINAL;
    }
  }

  calculateStylingProducts(formData) {
    const stylingChoices = formData.stylingProductsArray || [];
    const concernChoices = formData.concernArray || [];
    let selectedStylingProduct = HairQuiz.StylingProducts.HAIR_BALM;

    if (concernChoices.includes('breakage_damage')) {
      selectedStylingProduct = HairQuiz.StylingProducts.BOND_SERUM;
    } else if (stylingChoices.includes('gel')) {
      selectedStylingProduct = HairQuiz.StylingProducts.GEL;
    } else if (stylingChoices.includes('styling_cream')) {
      selectedStylingProduct = HairQuiz.StylingProducts.HAIR_BALM;
    } else if (stylingChoices.includes('hair_oil_serum')) {
      selectedStylingProduct = HairQuiz.StylingProducts.HAIR_OIL;
    } else if (stylingChoices.includes('texturizing_beach_spray')) {
      selectedStylingProduct = HairQuiz.StylingProducts.UNDRESSED;
    } else if (stylingChoices.includes('dry_shampoo_powder')) {
      selectedStylingProduct = HairQuiz.StylingProducts.POWDER;
    } else if (stylingChoices.includes('wax_pomade')) {
      selectedStylingProduct = HairQuiz.StylingProducts.WAX;
    }

    const defaultProducts = [HairQuiz.StylingProducts.PRE_WASH, HairQuiz.StylingProducts.PRIMER];
    return [selectedStylingProduct, ...defaultProducts].join(',');
  }

  calculateProductRecommendations(formData) {
    const newWashRecommendation = this.calculateNewWashProductRecommendation(formData);
    const stylingProductsRecommendation = this.calculateStylingProducts(formData);
    return `${newWashRecommendation},${stylingProductsRecommendation}`;
  }

  generateResultsPageUrl(productRecommendations) {
    const baseUrl = 'https://hairstory.com/pages/bundle-builder';
    const urlParams = new URLSearchParams();
    urlParams.set('view', 'routine');
    urlParams.set('routine', productRecommendations);
    return `${baseUrl}?${urlParams.toString()}`;
  }

  transformProductRecommendations(productRecommendations) {
    const productList = productRecommendations.split(',');
    return productList.map(handle => HairQuiz.PRODUCT_RECOMMENDATION_DICT[handle]).filter(Boolean);
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // ============================================================================
  // NAVIGATION LOGIC
  // ============================================================================

  shouldSkipShadeColorQuestion() {
    const currentQuestion = HairQuiz.QUESTIONS[this.state.currentStep];
    if (currentQuestion.id !== 'hair_color') return false;

    const hairColorAnswer = this.state.formData.hair_color;
    return !hairColorAnswer?.includes('color_my_hair');
  }

  calculatePrevStep() {
    let prevStep = this.state.currentStep - 1;
    const shadeColorIndex = HairQuiz.QUESTIONS.findIndex(q => q.id === 'shade_color');
    const hairColorIndex = HairQuiz.QUESTIONS.findIndex(q => q.id === 'hair_color');
    const hairColorAnswer = this.state.formData.hair_color;

    if (this.state.currentStep === shadeColorIndex + 1) {
      if (hairColorAnswer?.includes('color_my_hair')) {
        prevStep = shadeColorIndex;
      } else {
        prevStep = hairColorIndex;
      }
    } else if (this.state.currentStep === shadeColorIndex) {
      prevStep = hairColorIndex;
    }

    return Math.max(prevStep, 0);
  }

  nextStep() {
    let nextStep = this.state.currentStep + 1;

    if (this.shouldSkipShadeColorQuestion()) {
      nextStep += 1;
    }

    this.setState({ currentStep: nextStep });
    window.scrollTo({ top: 0 });
  }

  prevStep() {
    const prevStep = this.calculatePrevStep();
    this.currentCheckboxValues = [];
    this.showValidation = false;
    this.setState({ currentStep: prevStep });
  }

  // ============================================================================
  // QUIZ ACTIONS
  // ============================================================================

  startQuiz() {
    // Remove server-rendered intro
    const serverRenderedIntro = this.querySelector('.hair-quiz-intro');
    if (serverRenderedIntro) {
      serverRenderedIntro.remove();
    }
    this.setState({ phase: HairQuiz.PHASES.QUIZ });
  }

  completeQuiz() {
    // Calculate cohort
    const cohort = this.getUserCohort(this.state.formData);

    // Calculate product recommendations
    const recommendations = this.calculateProductRecommendations(this.state.formData);

    // Fire GTM event
    if (typeof window !== 'undefined' && window.dataLayer) {
      const productHandles = recommendations.split(',').filter(Boolean);
      const skus = productHandles
        .map(handle => HairQuiz.PRODUCT_RECOMMENDATION_DICT[handle]?.sku)
        .filter(Boolean);
      window.dataLayer.push({
        event: 'quiz_completed',
        product_skus: skus,
        product_count: skus.length
      });
    }

    this.setState({
      cohort,
      productRecommendations: recommendations,
      completed: true,
      phase: HairQuiz.PHASES.LOADING
    });

    // Fetch AI recommendation while loading screen is shown
    this.fetchAIRecommendation();
  }

  handleRadioSelect(value) {
    const currentQuestion = HairQuiz.QUESTIONS[this.state.currentStep];
    this.setFormData(currentQuestion.id, value);

    if (this.state.currentStep < HairQuiz.QUESTIONS.length - 1) {
      this.nextStep();
    } else {
      this.completeQuiz();
    }
  }

  handleCheckboxSelect(value) {
    if (value === 'none') {
      this.currentCheckboxValues = ['none'];
    } else if (this.currentCheckboxValues.includes('none')) {
      this.currentCheckboxValues = [value];
    } else {
      if (this.currentCheckboxValues.includes(value)) {
        this.currentCheckboxValues = this.currentCheckboxValues.filter(v => v !== value);
      } else {
        this.currentCheckboxValues = [...this.currentCheckboxValues, value];
      }
    }

    if (this.currentCheckboxValues.length > 0) {
      this.showValidation = false;
    }

    this.render();
    this.attachEventListeners();
  }

  handleNextClick() {
    if (this.currentCheckboxValues.length === 0) {
      this.showValidation = true;
      this.render();
      this.attachEventListeners();
      return;
    }

    const currentQuestion = HairQuiz.QUESTIONS[this.state.currentStep];
    this.setFormData(currentQuestion.id, this.currentCheckboxValues);
    this.currentCheckboxValues = [];
    this.showValidation = false;

    const isLastQuestion = this.state.currentStep === HairQuiz.QUESTIONS.length - 1;
    if (isLastQuestion) {
      this.setState({ phase: HairQuiz.PHASES.EMAIL_CAPTURE });
    } else {
      this.nextStep();
    }
  }

  // ============================================================================
  // MODAL HANDLING
  // ============================================================================

  openModal(modalType) {
    this.activeModal = modalType;
    this.render();
    this.attachEventListeners();
  }

  closeModal() {
    this.activeModal = null;
    this.render();
    this.attachEventListeners();
  }

  // ============================================================================
  // PRODUCT MODAL HANDLING
  // ============================================================================

  initializeProductModals() {
    if (!this.productModals || !this.productModals.length) return;

    this.productModals.forEach(modal => {
      const closeBtns = modal.querySelectorAll('[data-modal-close]');
      closeBtns.forEach(btn => {
        btn.addEventListener('click', () => this.closeProductModal(modal));
      });

      const backdrop = modal.querySelector('[data-modal-backdrop]');
      if (backdrop) {
        backdrop.addEventListener('click', (e) => {
          if (e.target === backdrop) {
            this.closeProductModal(modal);
          }
        });
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const openModal = Array.from(this.productModals).find(
          modal => !modal.classList.contains('hidden')
        );
        if (openModal) {
          this.closeProductModal(openModal);
        }
      }
    });
  }

  showProductModal(handle) {
    if (!this.productModals) return;

    const modal = Array.from(this.productModals).find(
      m => m.dataset.productModalHandle === handle
    );

    if (modal) {
      // Update button text for quiz context
      const backBtn = modal.querySelector('[data-modal-back-btn]');
      if (backBtn) {
        backBtn.textContent = 'Back to Results';
      }
      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
  }

  closeProductModal(modal) {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  // ============================================================================
  // API CALLS
  // ============================================================================

  async sendToKlaviyo(email) {
    try {
      if (!window.klaviyo) {
        console.warn('Klaviyo not loaded');
        return;
      }

      const recommendation = this.aiRecommendation;
      const handles = this.state.productRecommendations.split(',').filter(Boolean);

      // Build rich product array from both data sources
      const products = handles.map(handle => {
        const dictEntry = HairQuiz.PRODUCT_RECOMMENDATION_DICT[handle];
        const displayData = getQuizProductData(dictEntry?.name || handle);
        const aiProduct = recommendation?.products?.find(p => p.name === dictEntry?.name);
        return {
          name: dictEntry?.name || handle,
          handle: handle,
          sku: dictEntry?.sku || displayData.sku,
          price: displayData.price,
          variantId: displayData.variantId,
          productId: dictEntry?.id,
          productUrl: dictEntry?.url || displayData.productUrl,
          imageUrl: dictEntry?.image_url || displayData.imageUrl,
          description: aiProduct?.description || ''
        };
      });

      const routineUrl = this.generateResultsPageUrl(this.state.productRecommendations);

      // Identify first to ensure profile exists with properties
      window.klaviyo.identify({
        '$email': email,
        'Quiz Recommended Products': products.map(p => p.name).join(', ')
      });

      // Subscribe email to Klaviyo marketing (after identify)
      await subscribeToKlaviyoMarketing(email);

      const totalPrice = products.reduce((sum, p) => sum + parseFloat((p.price || '0').replace('$', '')), 0);
      const discountRate = getBundleDiscountRate(products.length);
      const discountedPrice = totalPrice * (1 - discountRate);

      window.klaviyo.track('Quiz Completed', {
        products: products,
        intro: recommendation?.intro || '',
        closing: recommendation?.closing || '',
        bundleBuilderUrl: routineUrl,
        productCount: products.length,
        totalPrice: totalPrice.toFixed(2),
        discountPercent: (discountRate * 100).toFixed(0),
        discountedPrice: discountedPrice.toFixed(2)
      });
    } catch (err) {
      console.error('Error sending to Klaviyo:', err);
    }
  }

  async fetchAIRecommendation() {
    try {
      // Build product names array from handles
      const handles = this.state.productRecommendations.split(',').filter(Boolean);
      const productNames = handles.map(
        handle => HairQuiz.PRODUCT_RECOMMENDATION_DICT[handle]?.name
      ).filter(Boolean);

      const response = await fetch('https://hairstory-ai-chat.vercel.app/api/quiz', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formData: this.state.formData,
          productRecommendations: productNames
        })
      });

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      const data = await response.json();
      this.aiRecommendation = data.recommendation || data;

      // Send to Klaviyo now that we have AI descriptions
      if (this.state.userEmail) {
        await this.sendToKlaviyo(this.state.userEmail);
      }

      // Transition to results phase
      this.setState({ phase: HairQuiz.PHASES.RESULTS });
    } catch (err) {
      console.error('Error fetching AI recommendation:', err);
      // Show error on the loading screen instead of silently redirecting
      const loadingContainer = this.querySelector('.hair-quiz-container');
      if (loadingContainer) {
        loadingContainer.innerHTML += `
          <div class="w-full max-w-[700px] mx-auto p-4 text-center">
            <p class="text-red-600 font-medium">Something went wrong loading your results.</p>
            <p class="text-red-500 text-sm mt-2">${err.message}</p>
            <a href="${this.generateResultsPageUrl(this.state.productRecommendations)}" class="inline-block mt-4 underline text-black">View results anyway</a>
          </div>
        `;
      }
    }
  }

  async addCustomBundle(productSkus, button) {
    const originalText = button.innerHTML;

    try {
      button.disabled = true;
      button.innerHTML = 'ADDING TO CART...';

      const cartCheck = await fetch('/cart.js');
      const cart = await cartCheck.json();

      if (cart.items.some(item => item.properties?._bundle)) {
        throw new Error('Cart already contains a bundle. Only one bundle per order allowed.');
      }

      const bundleItems = [];
      for (const sku of productSkus) {
        const productEntry = Object.values(QUIZ_PRODUCT_DATA).find(p => p.sku === sku);
        if (!productEntry || !productEntry.variantId) {
          throw new Error(`Variant ID not found for SKU: ${sku}.`);
        }

        bundleItems.push({
          id: productEntry.variantId,
          quantity: 1,
          properties: {
            _bundle: 'true'
          }
        });
      }

      const cartPayload = {
        items: bundleItems,
        sections: 'v2-cart-drawer,v2-cart-icon-bubble,v2-cart-recommendations',
        sections_url: window.location.pathname
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartPayload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      const bundleBuilder = document.querySelector('bundle-builder');
      if (bundleBuilder) {
        bundleBuilder.disableBundleBuilder();
      }

      // Update cart drawer (v2 API)
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.renderSections(data.sections, 'add', 'Hair Quiz Bundle');
        cartDrawer.open();
      }

      document.dispatchEvent(new CustomEvent('cart-update', {
        detail: { source: 'custom-bundle', cartData: data },
        bubbles: true
      }));

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          event: 'hairstory_add_bundle_to_cart',
          product_skus: productSkus
        });
      }

      button.innerHTML = '✓ ADDED TO CART';

      return data;

    } catch (error) {
      console.error('[Add Bundle] Error:', error);

      button.innerHTML = 'ERROR - TRY AGAIN';
      button.style.background = '#dc2626';

      setTimeout(() => {
        button.innerHTML = originalText;
        button.style.background = '#000';
        button.disabled = false;
      }, 3000);

      alert(error.message || 'Failed to add bundle to cart. Please try again.');

      throw error;
    }
  }

  // ============================================================================
  // PROGRESS BAR CALCULATION
  // ============================================================================

  getProgressInfo() {
    const hairColorAnswer = this.state.formData.hair_color;
    const showsShadeColor = hairColorAnswer === 'color_my_hair';
    const shadeColorIndex = HairQuiz.QUESTIONS.findIndex(q => q.id === 'shade_color');

    const totalSteps = showsShadeColor ? HairQuiz.QUESTIONS.length : HairQuiz.QUESTIONS.length - 1;

    let displayStep = this.state.currentStep + 1;
    if (!showsShadeColor && this.state.currentStep >= shadeColorIndex) {
      displayStep = this.state.currentStep;
    }

    return { totalSteps, displayStep, showsShadeColor, shadeColorIndex };
  }

  // ============================================================================
  // RENDER METHODS
  // ============================================================================

  render() {
    const { phase } = this.state;

    // Detach product modals before wiping innerHTML so they survive re-renders
    const modals = this.querySelectorAll('[data-product-modal-handle]');
    const modalFragment = document.createDocumentFragment();
    modals.forEach(modal => modalFragment.appendChild(modal));

    // Intro is server-rendered via Liquid, only render quiz, loading, and results phases
    if (phase === HairQuiz.PHASES.QUIZ) {
      this.innerHTML = this.renderQuiz();
    } else if (phase === HairQuiz.PHASES.EMAIL_CAPTURE) {
      this.innerHTML = this.renderEmailCapture();
      this.attachEmailEventListeners();
    } else if (phase === HairQuiz.PHASES.LOADING) {
      this.innerHTML = this.renderLoading();
    } else if (phase === HairQuiz.PHASES.RESULTS) {
      this.innerHTML = this.renderResults();
    }

    // Re-append product modals
    this.appendChild(modalFragment);

    // Re-cache modal references
    this.productModals = this.querySelectorAll('[data-product-modal-handle]');
  }

  renderEmailCapture() {
    const { totalSteps } = this.getProgressInfo();

    // Build fully completed progress bar
    let segments = '';
    for (let i = 0; i < totalSteps; i++) {
      segments += `
        <div class="h-full flex-1 overflow-hidden rounded-full bg-gray-200">
          <div class="bg-hs-orange h-full rounded-full transition-all duration-300" style="width: 100%"></div>
        </div>
      `;
    }

    return `
      <div class="hair-quiz-container bg-brand-secondary-800 flex flex-col min-h-[calc(100vh-122px)] lg:min-h-[calc(100vh-134px)]">
        <div class="bg-brand-secondary-800 flex h-[28px] w-full flex-col justify-center border-b border-black px-4 pt-[5px] pb-[5px] lg:h-[70px] lg:px-8">
          <p class="mb-2 hidden text-center text-sm text-black lg:block">Complete!</p>
          <div class="flex h-[10px] w-full gap-1">${segments}</div>
        </div>
        <form class="bg-brand-secondary-800 flex min-h-[calc(100vh-122px)] flex-col justify-start lg:min-h-[calc(100vh-183px)] lg:justify-center" onsubmit="return false;">
          <div class="mx-auto flex w-full flex-col items-center justify-start px-6 pt-8 md:max-w-[800px] md:px-0 md:pt-0">
            <h2 class="font-condensed mb-[10px] text-center text-3xl leading-[30px] font-semibold uppercase text-black md:mb-6 md:text-5xl md:leading-[48px]">
              Enter your email to get a copy of your results
            </h2>
            <div class="w-full md:max-w-[550px] mb-6">
              <input
                type="email"
                id="quiz-email-input"
                placeholder="Email address"
                required
                pattern="^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$"
                class="h-12 w-full border border-black bg-white px-4 text-sm text-black placeholder:text-brand-secondary-200 transition-all duration-300 ease-in-out focus:outline-none focus:ring-1 focus:ring-black"
              />
              <p class="quiz-email-error hidden mt-2 text-sm text-red-500">Please enter a valid email address</p>
            </div>
          </div>
          <div class="mx-auto flex w-full max-w-[606px] flex-col items-center justify-center px-6 md:max-w-[800px]">
            <button
              type="button"
              class="quiz-email-submit-btn bg-brand-secondary-200 mb-6 w-full cursor-pointer rounded-none px-8 py-3 text-sm font-bold tracking-wide text-white uppercase md:max-w-[295px]"
            >
              Email my results
            </button>
            <div class="mb-4 flex items-center justify-center lg:mb-0">
              <button
                type="button"
                class="quiz-skip-btn flex cursor-pointer items-center p-0 text-sm text-black underline" style="text-underline-offset: 4px;"
              >
                Skip ahead to my results
                <svg class="ml-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <p class="font-secondary mt-6 text-center text-xs text-brand-secondary-200 opacity-80">
              By submitting my email address, I consent to receive special offers, newsletters, and updates via email. For more information, please consult our
              <a href="https://hairstory.com/pages/privacy-policy" target="_blank" rel="noreferrer" class="underline hover:cursor-pointer">Privacy Policy</a>
              and
              <a href="https://hairstory.com/pages/terms-of-use" target="_blank" rel="noreferrer" class="underline hover:cursor-pointer">Terms and Conditions.</a>
            </p>
          </div>
        </form>
      </div>
    `;
  }

  attachEmailEventListeners() {
    const submitBtn = this.querySelector('.quiz-email-submit-btn');
    const skipBtn = this.querySelector('.quiz-skip-btn');
    const emailInput = this.querySelector('#quiz-email-input');
    const emailError = this.querySelector('.quiz-email-error');

    if (submitBtn && emailInput) {
      submitBtn.addEventListener('click', async () => {
        const email = emailInput.value.trim();
        const emailPattern = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

        if (!email || !emailPattern.test(email)) {
          if (emailError) emailError.classList.remove('hidden');
          emailInput.classList.add('border-red-500');
          return;
        }

        // Show loading state
        submitBtn.disabled = true;
        submitBtn.classList.add('opacity-75', 'cursor-wait');
        submitBtn.textContent = 'Sending...';

        this.setState({ userEmail: email });
        this.completeQuiz();
      });
    }

    if (skipBtn) {
      skipBtn.addEventListener('click', () => {
        this.completeQuiz();
      });
    }

    // Clear error on input
    if (emailInput && emailError) {
      emailInput.addEventListener('input', () => {
        emailError.classList.add('hidden');
        emailInput.classList.remove('border-red-500');
      });
    }
  }

  renderQuiz() {
    const currentQuestion = HairQuiz.QUESTIONS[this.state.currentStep];
    const { totalSteps, displayStep } = this.getProgressInfo();

    return `
      <div class="hair-quiz-container bg-brand-secondary-800 flex flex-col min-h-[calc(100vh-122px)] lg:min-h-[calc(100vh-134px)]">
        ${this.renderProgressBar(displayStep, totalSteps)}
        <form class="bg-brand-secondary-800 flex min-h-[calc(100vh-122px)] flex-col justify-start lg:min-h-[calc(100vh-183px)] lg:justify-center" onsubmit="return false;">
          ${this.renderQuestion(currentQuestion)}
          <div class="mx-auto flex w-full max-w-[606px] flex-col items-center justify-center px-6 md:max-w-[800px]">
            ${this.showValidation && this.currentCheckboxValues.length === 0 ? `
              <p class="font-bold text-red-500" id="checkboxError">Please select an option</p>
            ` : ''}

            <div class="mb-4 flex items-center justify-between gap-8 lg:mb-0">
              ${this.state.currentStep > 0 ? `
                <button
                  type="button"
                  class="quiz-back-btn relative flex cursor-pointer items-center p-0 text-sm text-black after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:origin-left after:scale-x-0 after:bg-black after:transition-transform after:duration-300 hover:after:scale-x-100"
                >
                  <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  BACK
                </button>
              ` : ''}

              ${currentQuestion.type === 'checkbox' ? `
                <button
                  type="button"
                  class="quiz-next-btn relative flex cursor-pointer items-center p-0 text-sm text-black after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:origin-left after:scale-x-0 after:bg-black after:transition-transform after:duration-300 hover:after:scale-x-100"
                >
                  NEXT
                  <svg class="ml-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              ` : ''}
            </div>
          </div>
        </form>
        ${this.renderModal()}
      </div>
    `;
  }

  renderProgressBar(displayStep, totalSteps) {
    let segments = '';
    for (let i = 0; i < totalSteps; i++) {
      const isCompleted = i < displayStep - 1;
      const isCurrent = i === displayStep - 1;
      const width = isCompleted ? '100%' : isCurrent ? '8px' : '0%';

      segments += `
        <div class="h-full flex-1 overflow-hidden rounded-full bg-gray-200">
          <div class="bg-hs-orange h-full rounded-full transition-all duration-300" style="width: ${width}"></div>
        </div>
      `;
    }

    return `
      <div class="bg-brand-secondary-800 flex h-[28px] w-full flex-col justify-center border-b border-black px-4 pt-[5px] pb-[5px] lg:h-[70px] lg:px-8">
        <p class="mb-2 hidden text-center text-sm text-black lg:block">${displayStep} of ${totalSteps}</p>
        <div class="flex h-[10px] w-full gap-1">${segments}</div>
      </div>
    `;
  }

  renderQuestion(question) {
    const isImageQuestion = question.id === 'hair_texture' || question.id === 'hair_type' || question.id === 'hair_color';

    return `
      <div class="mx-auto flex w-full flex-col items-center justify-start px-6 pt-8 pb-8 md:max-w-[800px] md:px-0 md:pt-0">
        <h2 class="font-base mb-4 text-center text-2xl leading-[1.2] text-black md:text-[30px]">
          ${question.text}
        </h2>
        ${question.subtext ? `
          <p class="text-brand-secondary-200 -mt-2 mb-4 text-center text-sm md:text-base">
            ${question.subtext}
          </p>
        ` : ''}

        ${question.type === 'checkbox'
          ? this.renderCheckboxGroup(question)
          : this.renderRadioGroup(question, isImageQuestion)
        }

        ${question.modal ? this.renderModalTrigger(question.modal) : ''}
      </div>
    `;
  }

  renderRadioGroup(question, isImageQuestion) {
    const optionsHtml = question.options.map((option) => {
      if (option.image) {
        return `
          <div class="quiz-radio-option w-full lg:flex-1" data-value="${option.value}">
            <div class="flex h-full w-full cursor-pointer flex-row items-center border border-black bg-white p-2 transition-colors duration-200 lg:flex-col lg:p-4 hover:border-gray-600">
              <img
                src="${option.image}"
                alt="${option.label}"
                class="mr-3 h-[90px] min-h-[90px] w-[90px] min-w-[90px] object-cover object-top lg:mr-0 lg:mb-1 lg:h-[200px] lg:min-h-[200px] lg:w-[200px] lg:min-w-[200px] lg:object-cover lg:object-top"
              />
              <div class="flex flex-col lg:items-center lg:text-center">
                <p class="font-base text-brand-secondary-200 text-base leading-6 lg:mt-2 lg:leading-none">
                  ${option.label}
                </p>
                ${option.subtext ? `
                  <p class="font-base text-brand-secondary-200 text-xs opacity-80">
                    ${option.subtext}
                  </p>
                ` : ''}
              </div>
            </div>
          </div>
        `;
      } else {
        return `
          <div
            class="quiz-radio-option flex h-12 w-full cursor-pointer items-center justify-center border border-black px-4 text-center text-xs font-medium tracking-wider uppercase transition-colors duration-200 md:max-w-[295px] lg:text-sm bg-white text-black hover:bg-black hover:text-white"
            data-value="${option.value}"
          >
            ${option.label}
          </div>
        `;
      }
    }).join('');

    const containerClasses = isImageQuestion
      ? 'flex-col gap-2 lg:max-w-none lg:flex-row lg:flex-nowrap lg:gap-4'
      : question.options.length >= 4
        ? 'flex-row flex-wrap'
        : 'flex-col';

    return `
      <div class="flex w-full max-w-[700px] items-stretch justify-center gap-5 lg:gap-4 ${containerClasses}">
        ${optionsHtml}
      </div>
    `;
  }

  renderCheckboxGroup(question) {
    const optionsHtml = question.options.map((option) => {
      const isSelected = this.currentCheckboxValues.includes(option.value);
      const selectedClass = isSelected ? 'bg-black text-white' : 'bg-white text-black hover:bg-black hover:text-white';

      return `
        <div
          class="quiz-checkbox-option w-full border border-black px-4 uppercase transition-colors duration-200 hover:cursor-pointer md:max-w-[295px] ${selectedClass}"
          data-value="${option.value}"
        >
          <input
            id="${question.id}-${option.value}"
            type="checkbox"
            name="${question.id}"
            value="${option.value}"
            ${isSelected ? 'checked' : ''}
            class="sr-only"
          />
          <label
            for="${question.id}-${option.value}"
            class="flex h-12 w-full cursor-pointer items-center justify-center text-center text-xs font-medium tracking-wider lg:text-sm"
          >
            ${option.label}
          </label>
        </div>
      `;
    }).join('');

    const containerClasses = question.options.length >= 4 ? 'flex-row flex-wrap' : 'flex-col';

    return `
      <div class="justify-left flex w-full max-w-[606px] items-center gap-5 lg:gap-4 ${containerClasses}">
        ${optionsHtml}
      </div>
    `;
  }

  renderModalTrigger(modalType) {
    const text = modalType === 'HairTypeModal' ? 'Not sure?' : 'Why we ask this';

    return `
      <button
        class="quiz-modal-trigger mt-6 flex items-center justify-center text-sm text-black"
        data-modal="${modalType}"
      >
        <p class="underline ${modalType === 'HairTypeModal' ? 'mt-2.5 ml-2' : ''}">
          ${text}
        </p>
      </button>
    `;
  }

  renderModal() {
    if (!this.activeModal) return '';

    if (this.activeModal === 'HairTypeModal') {
      return this.renderHairTypeModal();
    } else if (this.activeModal === 'WhyWeAskModal') {
      return this.renderWhyWeAskModal();
    }
    return '';
  }

  renderHairTypeModal() {
    const hairTypesHtml = HairQuiz.HAIR_TYPE_LIST.map(({ hairType, hairDescriptor, description }) => `
      <div>
        <div class="flex items-start">
          <dt class="font-semibold whitespace-nowrap w-[50px] mr-3">${hairType}</dt>
          <dd class="flex-1">
            <div class="font-medium">${hairDescriptor}</div>
            <div class="text-sm text-gray-600 mt-1">${description}</div>
          </dd>
        </div>
      </div>
    `).join('');

    return `
      <div class="quiz-modal-overlay fixed inset-0 bg-black/25 z-50">
        <div class="fixed inset-0 overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-4 text-center">
            <div class="w-full max-w-md transform overflow-hidden bg-white px-6 py-8 text-left align-middle shadow-xl transition-all relative">
              <button class="quiz-modal-close absolute top-4 right-4 hover:cursor-pointer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div class="flex flex-col w-full">
                <h2 class="mb-4 text-xl font-semibold uppercase tracking-wide">YOUR HAIR TYPES</h2>
                <p class="mb-4 text-sm text-gray-700">
                  This hair typing system helps identify your natural curl pattern, from
                  straight (1A) to kinky-coily (4C). Each type describes the shape and
                  tightness of your curls, which helps us recommend the right level of
                  moisture, support, and cleansing.
                </p>
                <p class="mb-6 text-sm text-gray-700">
                  You might not fit perfectly into one category — just choose the one
                  that feels closest!
                </p>
                <dl class="flex flex-col space-y-3">
                  ${hairTypesHtml}
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  renderWhyWeAskModal() {
    return `
      <div class="quiz-modal-overlay fixed inset-0 bg-black/25 z-50">
        <div class="fixed inset-0 overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-4 text-center">
            <div class="w-full max-w-md transform overflow-hidden bg-white px-6 py-8 text-left align-middle shadow-xl transition-all relative">
              <button class="quiz-modal-close absolute top-4 right-4 hover:cursor-pointer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div class="flex w-full flex-col">
                <h2 class="text-xl font-semibold tracking-wide text-black uppercase">WHY WE ASK THIS</h2>
                <hr class="mb-6 border-t border-[#e6e6e6]" />
                <p class="text-sm leading-relaxed text-black">
                  Knowing your hair's texture helps us select products formulated
                  specifically for your hair's unique needs—ensuring optimal hydration,
                  volume, and styling results. Fine hair can get weighed down easily,
                  while thick or coarse hair usually needs more moisture and richer
                  formula.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  renderLoading() {
    return `
      <style>
        @keyframes quizBounce {
          0%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-12px); }
        }
        .quiz-loading-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: var(--color-hs-orange, #f97316);
          animation: quizBounce 1.2s ease-in-out infinite;
        }
      </style>
      <div class="hair-quiz-container bg-brand-secondary-800 flex flex-col min-h-[calc(100vh-122px)] lg:h-[calc(100vh-134px)] justify-center">
        <div class="w-full max-w-[700px] mx-auto p-4">
          <div class="flex items-center justify-center gap-3 mb-8">
            <span class="quiz-loading-dot" style="animation-delay: 0s;"></span>
            <span class="quiz-loading-dot" style="animation-delay: 0.2s;"></span>
            <span class="quiz-loading-dot" style="animation-delay: 0.4s;"></span>
          </div>
          <h2 class="font-condensed text-black text-center text-[40px]/[48px] font-semibold uppercase">
            CALCULATING YOUR PERFECT MATCH
          </h2>
          <p class="text-black text-center text-base font-normal mt-4">
            Hold on just a sec while we put together your personalized hair ritual...
          </p>
        </div>
      </div>
    `;
  }

  renderResults() {
    const recommendation = this.aiRecommendation;
    if (!recommendation) return this.renderLoading();

    const products = recommendation.products || [];
    const introText = recommendation.intro || 'Here are your personalized recommendations:';
    const closingText = recommendation.closing || '';
    const reviewData = recommendation.review || null;

    // Split into essential (first 2) and additional
    const essentialProducts = products.slice(0, 2);
    const additionalProducts = products.slice(2);

    // Build handles, skus, and total price
    const handles = [];
    const skus = [];
    let totalPrice = 0;

    products.forEach(product => {
      const productData = getQuizProductData(product.name);
      if (productData.handle) handles.push(productData.handle);
      if (productData.sku) skus.push(productData.sku);
      if (productData.price) {
        totalPrice += parseFloat(productData.price.replace('$', ''));
      }
    });

    const routineUrl = `https://hairstory.com/pages/bundle-builder?view=routine&routine=${handles.join(',')}`;

    // Fire GTM event
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'quiz_skus_recommended',
        product_skus: skus,
        product_count: products.length
      });
    }

    // Build product cards HTML
    let cardsHtml = '';

    if (essentialProducts.length > 0) {
      cardsHtml += `<div class="product-section-title">Essential Products (${essentialProducts.length})</div>`;
      essentialProducts.forEach(product => {
        const productData = getQuizProductData(product.name);
        const imageUrl = productData.imageUrl || '';

        cardsHtml += `
          <div class="product-card"
               data-product-info-trigger="${productData.handle || ''}"
               style="cursor: pointer;">
            <div class="product-card-image">
              <img src="${imageUrl}" alt="${productData.name}" onerror="this.style.display='none'">
            </div>
            <div class="product-card-content">
              <h3 class="product-name">${productData.name}</h3>
              <div class="product-description">${product.description}</div>
              <a class="product-learn-more" href="#">LEARN MORE</a>
            </div>
          </div>
        `;
      });
    }

    if (additionalProducts.length > 0) {
      cardsHtml += `<div class="product-section-title">Additional Recommendations (${additionalProducts.length})</div>`;
      additionalProducts.forEach(product => {
        const productData = getQuizProductData(product.name);
        const imageUrl = productData.imageUrl || '';

        cardsHtml += `
          <div class="product-card"
               data-product-info-trigger="${productData.handle || ''}"
               style="cursor: pointer;">
            <div class="product-card-image">
              <img src="${imageUrl}" alt="${productData.name}" onerror="this.style.display='none'">
            </div>
            <div class="product-card-content">
              <h3 class="product-name">${productData.name}</h3>
              <div class="product-description">${product.description}</div>
              <a class="product-learn-more" href="#">LEARN MORE</a>
            </div>
          </div>
        `;
      });
    }

    // Bundle pricing
    const totalProducts = products.length;
    let discount = 0;
    let savingsHtml = '';
    if (totalProducts === 3) {
      discount = 0.15;
      savingsHtml = `<div class="product-savings">Oh and when you bundle all ${totalProducts} you <strong>save 15%</strong>.</div>`;
    } else if (totalProducts >= 4) {
      discount = 0.20;
      savingsHtml = `<div class="product-savings">Oh and when you bundle all ${totalProducts} you <strong>save 20%</strong>.</div>`;
    }

    const originalPrice = totalPrice > 0 ? totalPrice : 180;
    const discountedPrice = originalPrice * (1 - discount);

    // Review card
    let reviewHtml = '';
    if (reviewData) {
      reviewHtml = `
        <div class="review-card">
          <div class="review-header">
            <div class="review-rating">${'★'.repeat(5)}</div>
            <div class="review-meta">
              <span class="review-author">${this.escapeHtml(reviewData.reviewer_name || 'Anonymous')}</span>
              ${reviewData.hair_type ? `<span class="review-hair-type">${this.escapeHtml(reviewData.hair_type)}</span>` : ''}
            </div>
          </div>
          ${reviewData.review_title ? `<div class="review-title">${this.escapeHtml(reviewData.review_title)}</div>` : ''}
          <div class="review-content">${this.escapeHtml(reviewData.review_content)}</div>
          ${reviewData.product_title ? `<div class="review-product">Review for: ${this.escapeHtml(reviewData.product_title)}</div>` : ''}
        </div>
      `;
    }

    return `
      <div class="hair-quiz-container bg-brand-secondary-800 flex flex-col min-h-[calc(100vh-122px)] lg:min-h-[calc(100vh-134px)]">
        <div class="w-full max-w-[800px] mx-auto p-6 md:p-10">
          <h2 class="font-condensed text-black text-center text-[26px]/[26px] md:text-[40px]/[48px] font-semibold uppercase mb-6">
            YOUR PERSONALIZED ROUTINE
          </h2>
          <div class="product-cards-intro">${introText}</div>
          ${cardsHtml}
          ${closingText ? `<div class="product-cards-footer">${closingText}</div>` : ''}
          ${savingsHtml}
          <button class="add-bundle-btn"
                  data-product-click
                  data-routine-url="${routineUrl}"
                  data-click-type="add_bundle_button"
                  data-product-skus='${JSON.stringify(skus)}'>
            ADD <span class="bundle-text">BUNDLE </span>TO CART – <span class="btn-price-original">$${originalPrice.toFixed(2)}</span> <span class="btn-price-discounted">$${discountedPrice.toFixed(2)}</span>
          </button>
          <div class="customize-bundle">
            Want to add or remove a product? <a href="${routineUrl}" class="customize-bundle-link"
            data-product-click
            data-routine-url="${routineUrl}"
            data-click-type="customize_link"
            data-product-skus='${JSON.stringify(skus)}'>Customize Bundle</a>
          </div>
          ${reviewHtml}
        </div>
      </div>
    `;
  }

  // ============================================================================
  // EVENT LISTENERS
  // ============================================================================

  attachEventListeners() {
    // Start button
    const startBtn = this.querySelector('.quiz-start-btn');
    if (startBtn) {
      startBtn.addEventListener('click', () => this.startQuiz());
    }

    // Radio options
    const radioOptions = this.querySelectorAll('.quiz-radio-option');
    radioOptions.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        this.handleRadioSelect(value);
      });
    });

    // Checkbox options
    const checkboxOptions = this.querySelectorAll('.quiz-checkbox-option');
    checkboxOptions.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        this.handleCheckboxSelect(value);
      });
    });

    // Back button
    const backBtn = this.querySelector('.quiz-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', () => this.prevStep());
    }

    // Next button
    const nextBtn = this.querySelector('.quiz-next-btn');
    if (nextBtn) {
      nextBtn.addEventListener('click', () => this.handleNextClick());
    }

    // Modal triggers
    const modalTriggers = this.querySelectorAll('.quiz-modal-trigger');
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const modalType = trigger.dataset.modal;
        this.openModal(modalType);
      });
    });

    // Modal close button
    const modalClose = this.querySelector('.quiz-modal-close');
    if (modalClose) {
      modalClose.addEventListener('click', () => this.closeModal());
    }

    // Modal overlay click
    const modalOverlay = this.querySelector('.quiz-modal-overlay');
    if (modalOverlay) {
      modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay || e.target.classList.contains('quiz-modal-overlay')) {
          this.closeModal();
        }
      });
    }

    // Results phase: product card clicks and bundle actions
    if (this.state.phase === HairQuiz.PHASES.RESULTS) {
      this.attachResultsEventListeners();
    }
  }

  attachResultsEventListeners() {
    // Product info triggers (open modal)
    const productInfoTriggers = this.querySelectorAll('[data-product-info-trigger]');
    productInfoTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const handle = trigger.dataset.productInfoTrigger;
        this.showProductModal(handle);
      });
    });

    // Product click actions (bundle button + customize link)
    const productClickElements = this.querySelectorAll('[data-product-click]');
    productClickElements.forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const clickType = element.dataset.clickType;
        const routineUrl = element.dataset.routineUrl;
        const productSkus = JSON.parse(element.dataset.productSkus);

        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer.push({
            event: 'quiz_recommendation_click',
            product_skus: productSkus,
            click_type: clickType
          });
        }

        if (clickType === 'add_bundle_button') {
          this.addCustomBundle(productSkus, element);
        } else {
          window.location.href = routineUrl;
        }
      });
    });
  }
}

// Register the custom element
customElements.define('hair-quiz', HairQuiz);
